import { Headings } from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Headings/Headings";

import ExtendedButton from "@src/stories/elements/ExtendedButton/ExtendedButton";

export default function StyleguideButtons() {
  return (
    <div className={'styleguide-components'}>
      <div className={'component-header'}>
        <Headings text={'Buttons'} type={'h2'} />
      </div>

      <div className="bg-mb-skim-milk p-8">
        <div className={'component-header'}>
          <Headings text={'Light/White'} type={'h3'} />
        </div>

        <div className={'flex flex-row justify-between mb-4'}>
          <div className={'col-span-2'}>
            <h5>Primary</h5>
          </div>

          <div className={'flex flex-row space-x-2 col-span-8'}>
            <ExtendedButton label={'Primary'} />

            <ExtendedButton
              icon="mindarc"
              label={'Primary'}
            />

            <ExtendedButton
              icon="mindarc"
              label={'Primary'}
              reverse
            />

            <ExtendedButton icon="mindarc" />
          </div>
        </div>

        <div className={'flex flex-row justify-between mb-4'}>
          <div className={'col-span-2'}>
            <h5>Secondary</h5>
          </div>

          <div className={'flex flex-row space-x-2 col-span-8'}>
            <ExtendedButton
              style="secondary"
              label={'Secondary'}
            />

            <ExtendedButton
              style="secondary"
              icon="mindarc"
              label={'Secondary'}
            />

            <ExtendedButton
              style="secondary"
              icon="mindarc"
              label={'Secondary'}
              reverse
            />

            <ExtendedButton
              style="secondary"
              icon="mindarc"
            />
          </div>
        </div>

        <div className={'flex flex-row justify-between mb-4'}>
          <div className={'col-span-2'}>
            <h5>Tertiary</h5>
          </div>

          <div className={'flex flex-row space-x-2 col-span-8'}>
            <ExtendedButton
              style="tertiary"
              label={'Tertiary'}
            />

            <ExtendedButton
              style="tertiary"
              icon="mindarc"
              label={'Tertiary'}
            />

            <ExtendedButton
              style="tertiary"
              icon="mindarc"
              label={'Tertiary'}
              reverse
            />

            <ExtendedButton
              style="tertiary"
              icon="mindarc"
            />
          </div>
        </div>

        <div className={'flex flex-row justify-between mb-4'}>
          <div className={'col-span-2'}>
            <h5>Text Button</h5>
          </div>

          <div className={'flex flex-row space-x-2 col-span-8'}>
            <ExtendedButton
              style="text"
              label={'Button'}
            />

            <ExtendedButton
              style="text"
              icon="mindarc"
              label={'Button'}
            />

            <ExtendedButton
              style="text"
              icon="mindarc"
              label={'Button'}
              reverse
            />

            <ExtendedButton
              style="text"
              icon="mindarc"
            />
          </div>
        </div>
      </div>

      <div className="p-4"></div>

      <div className="bg-mb-dark-leaf p-8 text-white">
        <div className={'component-header'}>
          <Headings text={'Dark'} type={'h3'} />
        </div>

        <div className={'flex flex-row justify-between mb-4'}>
          <div className={'col-span-2'}>
            <h5>Primary</h5>
          </div>

          <div className={'flex flex-row space-x-2 col-span-8'}>
            <ExtendedButton
              style="dark-primary"
              label={'Primary'}
            />

            <ExtendedButton
              style="dark-primary"
              icon="mindarc"
              label={'Primary'}
            />

            <ExtendedButton
              style="dark-primary"
              icon="mindarc"
              label={'Primary'}
              reverse
            />

            <ExtendedButton
              style="dark-primary"
              icon="mindarc"
            />
          </div>
        </div>

        <div className={'flex flex-row justify-between mb-4'}>
          <div className={'col-span-2'}>
            <h5>Secondary</h5>
          </div>

          <div className={'flex flex-row space-x-2 col-span-8'}>
            <ExtendedButton
              style="dark-secondary"
              label={'Secondary'}
            />

            <ExtendedButton
              style="dark-secondary"
              icon="mindarc"
              label={'Secondary'}
            />

            <ExtendedButton
              style="dark-secondary"
              icon="mindarc"
              label={'Secondary'}
              reverse
            />

            <ExtendedButton
              style="dark-secondary"
              icon="mindarc"
            />
          </div>
        </div>

        <div className={'flex flex-row justify-between mb-4'}>
          <div className={'col-span-2'}>
            <h5>Tertiary</h5>
          </div>

          <div className={'flex flex-row space-x-2 col-span-8'}>
            <ExtendedButton
              style="dark-tertiary"
              label={'Tertiary'}
            />

            <ExtendedButton
              style="dark-tertiary"
              icon="mindarc"
              label={'Tertiary'}
            />

            <ExtendedButton
              style="dark-tertiary"
              icon="mindarc"
              label={'Tertiary'}
              reverse
            />

            <ExtendedButton
              style="dark-tertiary"
              icon="mindarc"
            />
          </div>
        </div>

        <div className={'flex flex-row justify-between mb-4'}>
          <div className={'col-span-2'}>
            <h5>Text Button</h5>
          </div>

          <div className={'flex flex-row space-x-2 col-span-8'}>
            <ExtendedButton
              style="dark-text"
              label={'Button'}
            />

            <ExtendedButton
              style="dark-text"
              icon="mindarc"
              label={'Button'}
            />

            <ExtendedButton
              style="dark-text"
              icon="mindarc"
              label={'Button'}
              reverse
            />

            <ExtendedButton
              style="dark-text"
              icon="mindarc"
            />
          </div>
        </div>
      </div>
    </div>
  )
}